export const PerformingAgents = {title:'Top Performing Agents',data:[
    {name:'Emmanuel Yabo',value:'8,000,000'},
    {name:'Dan Rice',value:'6,500,000'},
    {name:'John Doe',value:'5,000,000'},
    {name:'Patience Yabo',value:'4,000,000'},
    {name:'Rila Jane',value:'1,500,000'},
    {name:'Semi Dotun',value:'1,000,000'},
    {name:'Lawal Jamiu',value:'1,000,000'}
]}